import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Btn, Input, Section } from "./kit";

export default function ChangePassword() {
  const { login } = useAuth();
  const [f, setF] = useState({ current: "", next: "", again: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (f.next !== f.again) return toast.error("New passwords don't match");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      login(data.token, data.user);
      setF({ current: "", next: "", again: "" });
      toast.success("Password changed. Other devices are signed out.");
    } catch (e2) {
      toast.error(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <Section title="Change password" icon={KeyRound} testid="change-password-section">
      <form onSubmit={submit} className="space-y-2">
        <Input type="password" autoComplete="current-password" placeholder="Current password" value={f.current} onChange={set("current")} required data-testid="change-current-password" />
        <Input type="password" autoComplete="new-password" placeholder="New password (8+ characters)" minLength={8} value={f.next} onChange={set("next")} required data-testid="change-new-password" />
        <Input type="password" autoComplete="new-password" placeholder="Repeat new password" value={f.again} onChange={set("again")} required data-testid="change-new-password-confirm" />
        <Btn className="w-full" loading={busy} data-testid="change-password-submit">Update password</Btn>
      </form>
    </Section>
  );
}
